import { CardHeader } from "@mui/material";
import { ReactNode } from "react";

export type ObjectAttachmentCardHeaderProps = {
    children?: ReactNode;
    title?: ReactNode;
    avatar?: ReactNode;
    subheader?: ReactNode;
    action?: ReactNode;
};

export function ObjectAttachmentCardHeader({ children, ...rest }: ObjectAttachmentCardHeaderProps) {
    return (
        <CardHeader
            sx={{
                padding: 1
            }}
            {...rest}
        >
            {children}
        </CardHeader>
    );
}